import { initializeApp } from "firebase/app";
import { getDatabase, onValue, ref } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCyIoDWkGY1JX-t8t4cXvJTGw4eLzoXeBI",
  authDomain: "vendortopay-fms.firebaseapp.com",
  projectId: "vendortopay-fms",
  storageBucket: "vendortopay-fms.firebasestorage.app",
  messagingSenderId: "953633780966",
  appId: "1:953633780966:web:f1ac39aaefce9b3c607727",
  measurementId: "G-02TXPV1Q6Y",
  databaseURL: "https://vendortopay-fms-default-rtdb.asia-southeast1.firebasedatabase.app"
};


const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
    

export { db, app,onValue,ref };
